import { createFileRoute, Outlet, Link, useLocation } from '@tanstack/react-router'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

export const Route = createFileRoute('/_app/settings/webhooks')({
  component: WebhooksLayout,
})

function WebhooksLayout() {
  const location = useLocation()
  const currentTab = location.pathname.includes('incoming') ? 'incoming' : 'outbound'

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">Webhooks</h3>
        <p className="text-sm text-muted-foreground">Logs de eventos e webhooks.</p>
      </div>
      <Tabs value={currentTab} className="w-full">
        <TabsList>
          <TabsTrigger value="outbound" asChild>
            <Link to="/settings/webhooks/outbound">Enviados</Link>
          </TabsTrigger>
          <TabsTrigger value="incoming" asChild>
            <Link to="/settings/webhooks/incoming">Recebidos</Link>
          </TabsTrigger>
        </TabsList>
      </Tabs>
      <Outlet />
    </div>
  )
}
